import React, { useState } from "react";
import { validate } from "validate.js";
import { useNavigate } from "react-router-dom";
import { Card, Form, Icon, Input, Button } from "antd";
import resetPasswordRules from "./validators";

const { Meta } = Card;
type Props = {
    token: string;
    isLoading: boolean;
    onSubmit: (token: string, password: string) => void;
};


export default function ResetPasswordForm({ token, isLoading, onSubmit }: Props) {
    const navigate = useNavigate();
    const [formState, setFormState] = useState({
        password: "",
        repeatPassword: "",
        validationErrors: {
            password: "",
            repeatPassword: ""
        }
    });

    const validateForm = () => {
        return validate(
            {
                password: formState.password,
                repeatPassword: formState.repeatPassword
            },
            resetPasswordRules
        );
    };

    const onFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const validationErrors = validateForm();

        if (!validationErrors) {
            setFormState({ ...formState, validationErrors: { password: "", repeatPassword: "" } });
            onSubmit(token, formState.password);
        } else {
            setFormState({ ...formState, validationErrors });
        }
    };

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState = { ...formState, validationErrors: { password: "", repeatPassword: "" }, [event.target.name]: event.target.value };
        setFormState(newState);
    };

    const onInputFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        const inputTextName = event.target.name;
        if (inputTextName !== "password" && inputTextName !== "repeatPassword") {
            return;
        }
        if (formState.validationErrors[inputTextName]) {
            const newState = {
                ...formState,
                validationErrors: { ...formState.validationErrors, [event.target.name]: "" }
            };
            setFormState(newState);
        }
    };

    const passwordError = formState.validationErrors.password && formState.validationErrors.password[0];
    const repeatPasswordError =
        formState.validationErrors.repeatPassword && formState.validationErrors.repeatPassword[0];

    return (
        <div className="reset-password-container">
            <div className="authentication-form-wrapper">
                <div className="auth-logo" />

                <Card className="auth-card" bordered={false}>
                    <div className="card-header">
                        <Meta title="Reset password" />
                    </div>
                    <Form className="reset-password-form" onSubmit={onFormSubmit}>
                        <Form.Item validateStatus={passwordError ? "error" : "validating"} help={passwordError}>
                            <Input
                                name="password"
                                prefix={<Icon type="lock" style={{ fontSize: "16px", color: "rgba(66,71,71,.54)" }} />}
                                type="password"
                                value={formState.password}
                                onChange={onInputChange}
                                onFocus={onInputFocus}
                                placeholder="Password"
                                autoComplete="new-password"
                            />
                        </Form.Item>
                        <Form.Item
                            validateStatus={repeatPasswordError ? "error" : "validating"}
                            help={repeatPasswordError}>
                            <Input
                                name="repeatPassword"
                                prefix={<Icon type="lock" style={{ fontSize: "16px", color: "rgba(66,71,71,.54)" }} />}
                                type="password"
                                value={formState.repeatPassword}
                                onChange={onInputChange}
                                onFocus={onInputFocus}
                                placeholder="Repeat password"
                                autoComplete="new-password"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                block
                                type="primary"
                                htmlType="submit"
                                className="reset-password-form-button"
                                loading={isLoading}>
                                Change password
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
                <div className="under-card-info">
                    <span className="fake-link" onClick={() => navigate("/auth/login")}>
                        <strong>Log in to your account</strong>
                    </span>
                </div>
            </div>
        </div>
    );
}
